/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2021, Zumper
 * @description relatedListings
 */

import { filterActions } from '@zumper/redux-ignore'
import * as constants from './constants'
import { relatedListingsReducer } from './reducers'

export const relatedListings = filterActions(relatedListingsReducer, Object.values(constants))
